import { Grid, Text } from '@simplywallst/ui-core';

export const FairValueTooltip = () => {
  return (
    <Grid template="auto auto / 220px" gap="16px">
      <Text typography="tiny">
        Current intrinsic value of a company based on an estimate of its
        potential future profits.{' '}
      </Text>
      <Text typography="tiny">
        Fair value can be your own guidance of a safe price to buy the stock.
        Analyst price targets and our quantitative fair value are available to
        help with your estimate.
      </Text>
    </Grid>
  );
};

export const CashValuationTooltip = () => {
  return (
    <Grid template="auto auto / 220px" gap="16px">
      <Text typography="tiny">
        Simply Wall St provides a Discounted Cash Flow Valuation estimate based
        on analyst forecasts of future free cash flow, plus additional
        assumptions.
      </Text>
      <Text typography="tiny">
        Discounted Cash Flow is a commonly trusted method used by analysts and
        well-known investors like Warren Buffett.
      </Text>
    </Grid>
  );
};
